module.exports = __webpack_public_path__ + "images/index/img01.42b6aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/shmei/img01.png
// module id = MuzO
// module chunks = 21